import axios from "axios";
import { env } from "../../shared/config/env";
import { attachAuthInterceptor } from "./authInterceptor";

const newsClient = axios.create({
  baseURL: env.api.news,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(newsClient);

export default newsClient;
